// media-library-image/media-library-image-ui.js

import { Plugin, icons } from 'ckeditor5/src/core';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import { ContextualBalloon, clickOutsideHandler } from '@ckeditor/ckeditor5-ui';
import FormView from './media-library-video-view';

export default class MediaLibraryVideoUi extends Plugin {

    init() {

        const editor = this.editor;

        // Create the balloon and the form view.
        this._balloon = this.editor.plugins.get( ContextualBalloon );
        this.formView = this._createFormView();

        // Register the button for this plugin
        editor.ui.componentFactory.add( 'mediaLibraryVideo', () => {

            const button = new ButtonView();

            const iconCameraVideo = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-camera-video" viewBox="0 0 16 16">\n' +
                '  <path fill-rule="evenodd" d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5zm11.5 5.175 3.5 1.556V4.269l-3.5 1.556v4.35zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2z"/>\n' +
                '</svg>';

            button.set( {
                label: 'Insert a Media Library video',
                icon: iconCameraVideo,
                tooltip: true
            });

            // Show the UI on button click.
            this.listenTo( button, 'execute', () => {
                this._showUI();
            } );

            return button;

        });

    }

    _createFormView() {

        const editor = this.editor;
        const formView = new FormView( editor.locale );

        // Execute the command after clicking the "Save" button.
        this.listenTo( formView, 'submit', () => {

            console.log(formView);



            // // Grab values from the abbreviation and title input fields.
            // let alt = formView.altInput.fieldView.element.value;
            // let width = formView.widthInput.fieldView.element.value;
            // let url = formView.imageUrlHidden.fieldView.element.value;
            //
            // let attributes = { 'source' : {
            //         src: url, alt: alt
            //     }
            // };
            //
            // const imageUtils = this.editor.plugins.get( 'ImageUtils' );
            //
            // let selectedElement = editor.model.document.selection.getSelectedElement();
            //
            // if ( imageUtils.isImage( selectedElement ) ) {
            //     //console.log('isImage');
            //     editor.model.change( writer => {
            //         writer.setAttribute( 'src', url, selectedElement );
            //         writer.setAttribute( 'alt', alt, selectedElement );
            //     } );
            //     if (width !== '') {
            //         editor.execute( 'resizeImage', { width: width } );
            //     }
            // } else {
            //     //console.log('insertImage');
            //     editor.execute( 'insertImage', attributes );
            //     if (width !== '') {
            //         editor.execute( 'resizeImage', { width: width } );
            //     }
            // }

            // Hide the form view after submit.
            this._hideUI();

        } );

        // Hide the form view after clicking the "Cancel" button.
        this.listenTo( formView, 'cancel', () => {
            this._hideUI();
        } );

        // Open the video uploader in a new tab
        this.listenTo( formView, 'upload', () => {
            this._openVideoUpload();
        } );

        // Refresh the list of videos
        this.listenTo( formView, 'refresh', () => {
            this._refreshVideoList();
        } );


        // Hide the form view when clicking outside the balloon.
        clickOutsideHandler( {
            emitter: formView,
            activator: () => this._balloon.visibleView === formView,
            contextElements: [ this._balloon.view.element ],
            callback: () => this._hideUI()
        } );

        return formView;
    }

    /**
     * Open the video uploader in a new tab
     * @private
     */
    _openVideoUpload() {
        window.open('/manager/content/media/upload','_blank');
    }

    /**
     * Rebuilds the video list for after an video is added for example
     *
     * @private
     */
    _refreshVideoList() {
        this._buildVideoPicker($('.ck-media-library-video-panel'));
    }

    _showUI() {

        //const selection = this.editor.model.document.selection;

        this.formView.withArrow = false;

        this._balloon.add( {
            view: this.formView,
            balloonClassName: 'ck-media-library-video-picker ck-reset_all-excluded',
            withArrow: false,
            position: this._getBalloonPositionData(),
            singleViewMode: true,
            stackId: 'ckMediaLibrary'
        } );

        // // Identify the selected element
        // let $img = $('figure.ck-widget.ck-widget_selected img');
        // let alt = '';
        // let src = '';
        // let width = '';
        // if ($img.length) {
        //     alt = $img.attr('alt');
        //     src = $img.attr('src');
        //     width = $img.css('width');
        //     if (alt) {
        //         this.formView.altInput.fieldView.element.value = alt;
        //         this.formView.altInput.fieldView.set('isEmpty', false);
        //     }
        //     if (width) {
        //         this.formView.widthInput.fieldView.element.value = width;
        //         this.formView.widthInput.fieldView.set('isEmpty', false);
        //     }
        //     if (src) {
        //         this.formView.imageUrlHidden.fieldView.value = src;
        //     }
        // }
        //
        // this.formView.formLoadingHidden.fieldView.value = true;

        this._buildVideoPicker($('.ck-media-library-video-panel'));

    }

    _hideUI() {
        // Clear the input field values and reset the form.
        //this.formView.altInput.fieldView.element.value = '';
        this.formView.videoIdHidden.fieldView.value = '';
        //this.formView.imageUrlHidden.fieldView.value = '';
        this.formView.element.reset();

        this._balloon.remove( this.formView );

        // Focus the editing view after inserting the abbreviation so the user can start typing the content
        // right away and keep the editor focused.
        this.editor.editing.view.focus();
    }

    _getBalloonPositionData() {

        const view = this.editor.editing.view;
        const viewDocument = view.document;
        let target = null;

        // Set a target position by converting view selection range to DOM
        target = () => view.domConverter.viewRangeToDom( viewDocument.selection.getFirstRange() );

        return {
            target
        };

    }

    _buildVideoPicker($target) {

        $('body').addClass('waiting');

        getVideoPicker()
            .then(
                (response) => {
                    // Insert the video picker
                    $target.html(response.data);
                    // Initialise the controls
                    initVideoPicker();
                    // Initialise the video select
                    this._initVideoSelect($target);
                    // Clear the progress cursor
                    $('body').removeClass('waiting');
                }
            )["catch"](function (error) {
            // Clear the progress cursor
            $('body').removeClass('waiting');
        });

    }

    _initVideoSelect($target) {

        // Make a local variable pointing to this, to avoid 'this' confusion inside the click function
        let obj = this;

        $target.find('.video-picker-video-wrapper').click(function() {

            // Set a class on the selected item
            $target.find('.video-picker-video-wrapper').removeClass('selected');
            $(this).addClass('selected');

            // Grab parameters from the selected item
            //let alt = $(this).attr('data-image-alt') ? $(this).attr('data-image-alt') : '';
            let id = $(this).attr('data-video-id');
            //let url = $(this).attr('data-image-url');

            // Set the field values - have to do it this way to ensure the change event is fired and the _updateIsEmpty method runs to handle label formatting
            obj.formView.videoIdHidden.fieldView.value = id;
            // if (obj.formView.formLoadingHidden.fieldView.value === false) {
            //     obj.formView.imageUrlHidden.fieldView.value = url;
            //     obj.formView.altInput.fieldView.element.value = alt;
            // }

        });

        // if (obj.formView.imageUrlHidden.fieldView.value !== '') {
        //     // Find the selected image and trigger the click event to set its class
        //     $('.image-picker-image-wrapper[data-image-url=\'' + obj.formView.imageUrlHidden.fieldView.value + '\']').trigger('click');
        // }

        obj.formView.formLoadingHidden.fieldView.value = false;

    }


}
